import { useState } from 'react';

import { api, errorMessage } from '../../lib/api';
import { Dialog } from '../Dialog';

export const DeleteDialog = ({
  proposal,
  onClose,
  onDeleted,
}: {
  proposal: { id: string; title: string; status: string; opens: number } | null;
  onClose: () => void;
  onDeleted: () => void;
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const remove = async () => {
    if (!proposal) return;
    setBusy(true);
    setError('');
    try {
      await api(`/api/admin/proposals/${proposal.id}`, { method: 'DELETE' });
      onDeleted();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!proposal} onClose={onClose} kicker="Excluir proposta" title={proposal?.title ?? ''}>
      <p className="muted">
        A proposta sai da plataforma junto com as versões, os acessos, as leituras e os pedidos. O link deixa de funcionar para todos. Não dá para desfazer.
      </p>
      {proposal?.status === 'accepted' && <p className="warn">Esta proposta já foi aceita. O registro do aceite também será apagado.</p>}
      {proposal && proposal.opens > 0 && proposal.status !== 'accepted' && <p className="warn">Ela já foi aberta {proposal.opens} {proposal.opens === 1 ? 'vez' : 'vezes'}.</p>}
      {error && <p className="error">{error}</p>}
      <div className="dialog-foot">
        <button className="btn btn-ghost" onClick={onClose}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={remove} disabled={busy}>
          {busy ? 'Excluindo…' : 'Excluir de vez'}
        </button>
      </div>
    </Dialog>
  );
};
